import {
	GET_CONFIGURATION_MANAGEMENT_SUMMARY_TABLE
} from '../actions/ConfigurationManagementActions';

const initialState = {
	configurationManagementSummaryTableData: []
};

const configurationManagementReducer = (state = initialState, action) => {
	switch (action.type) {
					case GET_CONFIGURATION_MANAGEMENT_SUMMARY_TABLE: {
						return {
							...state,
							configurationManagementSummaryTableData: action.configurationManagementSummaryTableData
						};
					}
					default: {
						return state;
					}
	}
};

export default configurationManagementReducer;
